class SocialPageController {

  constructor(SocialCategoryService, AlertService, LoaderService) {
    this.SocialCategoryService = SocialCategoryService;
    this.AlertService = AlertService;
    this.LoaderService = LoaderService;
  }

  $onInit() {
    var self = this;
    self.LoaderService.start();
    self.SocialCategoryService.getCategories()
        .then( (categories)=> self.categories = categories )
        .catch( (error)=> self.AlertService.error("There was a problem getting the categories") )
        .finally( () => self.LoaderService.stop() );
  }

  addHashtag(hashtagObj) {
      var self = this;
      var categoryIndex = self.categories.map(function(item) { return item.id; }).indexOf(hashtagObj.socialCategory);
      var hashtagAlreadyExists = false;

      // Strip actual hash (#) in case it was included
      hashtagObj.name = hashtagObj.name.split("#").join("");

      // Make sure the hashtag doesn't already exist in this category
      self.categories[categoryIndex].hashtags.forEach(function(hashtag) {
        if ( hashtag.name === hashtagObj.name ) {
          hashtagAlreadyExists = true;
          return; // no need to keep looping
        }
      });

      if ( !hashtagAlreadyExists ) {
        // Okay. But does the hashtag have text?
        if ( hashtagObj.name === "" || hashtagObj.name.split(" ").length === hashtagObj.name.length + 1 ) {
          self.AlertService.error("Your hashtag must have text.");
        } else {
          // Go ahead and save the hashtag
          self.LoaderService.start();
          self.SocialCategoryService.addHashtag(hashtagObj)
            .then( (hashtag) => {
                self.AlertService.success("Hashtag has been added");
                self.categories[categoryIndex].hashtags.push(hashtag);
            } )
            .catch( (error) => self.AlertService.error("There was a problem adding the hashtag") )
            .finally( () => {
                self.LoaderService.stop();
            });
        }
      } else {
        // Alert that the hashtag already exists and was not saved
        self.AlertService.error("The hashtag already exists in this category.");
      }
  }

    removeHashtag(data) {
        var self = this;

        self.LoaderService.start();

        self.SocialCategoryService.removeHashtag(data.socialCategory, data.hashtagId)
            .then( () => {

                self.AlertService.success("Hashtag has been removed");

                var categoryIndex = this.categories.map(function(item) { return item.id; })
                    .indexOf(data.socialCategory);

                var hashtagIndex = self.categories[categoryIndex].hashtags.map(function(item) { return item.id })
                    .indexOf(data.hashtagId);

                if(hashtagIndex !== -1){
                    self.categories[categoryIndex].hashtags.splice(hashtagIndex, 1);
                }
            } )
            .catch( (error) => self.AlertService.error("There was a problem adding the hashtag") )
            .finally( () => {
                self.LoaderService.stop();
            });
    }

}
SocialPageController.$inject =  ['SocialCategoryService', 'AlertService', 'LoaderService'];
export default SocialPageController;
